import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import sidebarData from "./SidebarData";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import { BACKEND_URL_DOC, BACKEND_URL_PORTAIL, LOG_URL, DOC_URL, COMPOUND_URL } from "../../config/const.js";
import { useTranslation } from "react-i18next";
import { withTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import quessLogs from "../../assets/images/quess_logs.svg"; 
import quessDocs from "../../assets/images/quess_docs.svg";
import quesslms from "../../assets/images/quess_lms.svg";
import quesscompound from "../../assets/images/quess_compound.svg";
import quessControle from "../../assets/images/quess_controle.svg";
import Avatar from '../../components/Common/Avatar';
import LmsConnect from "./LmsConnect.js";
import './styles.css';

const Sidebar = (props) => {
  const [hasQuessLogs, setHasQuessLogs] = useState(false);
  const [hasQuessCompound, setHasQuessCompound] = useState(false);
  const [hasQuessControle, setHasQuessControle] = useState(false);
  const [hasQuessDocs, setHasQuessDocs] = useState(false);
  const [hasQuessLms, setHasQuessLms] = useState(false);
  const [hasAdmin, setHasAdmin] = useState(null);
  const [currentOrg, setCurrentOrg] = useState(localStorage.getItem('currentOrg'));
  const [isUser, setIsUser] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openModalLoginLms, setOpenModalLoginLms] = useState(false);
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user")));
  const [menuKey, setMenuKey] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false);
  const metisMenuRef = useRef(null);

  const { t } = useTranslation();
  const ref = useRef();
  const history = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      setUser(storedUser);
      setIsUser(!!storedUser);
    };
  
    window.addEventListener('storage', handleStorageChange);
    
    const timeoutId = setTimeout(() => {
      handleStorageChange();
      setLoading(false);
    }, 2000);
  
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async (org) => {
      if (!org || !isMounted) return;
      
      try {
        await Promise.all([
          getPermissions(org),
          getSolutionsByGroup(org),
          getgroupdocspermissionByGroup(org),
          getgrouplmspermission(org)
        ]);
        
        if (isMounted) {
          setDataLoaded(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (isMounted) {
          setDataLoaded(true);
        }
      }
    };

    if (currentOrg) {
      fetchData(currentOrg);
    }

    const interval = setInterval(() => {
      const updatedOrg = localStorage.getItem('currentOrg');
      if (updatedOrg !== currentOrg && isMounted) {
        setCurrentOrg(updatedOrg);
        setDataLoaded(false);
        fetchData(updatedOrg);
      }
    }, 500);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [currentOrg]);

  const getPermissions = (idGroup) => {
    return new Promise(async (resolve) => {
      try {
        const response = await axios.get(
          `${BACKEND_URL_PORTAIL}api/permissions/${idGroup}`,
          config
        );
        if (Array.isArray(response)) {
          const hasAdminRole = response.includes("admin") || response.includes("superAdmin");
          setHasAdmin(hasAdminRole);
        }
        resolve();
      } catch (error) {
        console.error("Erreur lors de la récupération des permissions :", error);
        setHasAdmin(false);
        resolve();
      }
    });
  };

  useEffect(() => {
    if (dataLoaded && hasAdmin !== null) {
      setMenuKey(prev => prev + 1);
    }
  }, [hasAdmin, dataLoaded]);

  function getUserInfos(idOrganisation, idModule) {      
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    };
    const data = {
      idModule,
      idOrganisation
    };
    axios.post(BACKEND_URL_PORTAIL + 'api/userInfos', data, config)
      .then(response => {
        localStorage.setItem('userRoles', JSON.stringify(response.userRoles));
      });
  }

  const getSolutionsByGroup = (idGroup) => {
    return new Promise((resolve) => {
      const data = {
        idOrganisation: idGroup,
      };
      axios
        .post(BACKEND_URL_PORTAIL + "api/getSolutionsByUserId", data, config)
        .then((response) => {
          localStorage.setItem("currentSolution", JSON.stringify(response));
          setHasQuessLogs(response.some((item) => item.name === "quessLogs"));
          setHasQuessControle(response.some((item) => item.name === "quessControl"));
          setHasQuessCompound(response.some((item) => item.name === "quessCompounding"));
          
          if (!isEmpty(localStorage.getItem('currentSolution'))) {
            getUserInfos(idGroup, JSON.parse(localStorage.getItem('currentSolution'))[0].id);
          } else {
            getUserInfos(idGroup, response[0].id);
          }
          resolve();
        })
        .catch((error) => {
          console.error("Error in getSolutionsByGroup:", error);
          resolve();
        });
    });
  };

  const getgroupdocspermissionByGroup = (idGroup) => {
    return new Promise((resolve) => {
      axios
        .get(BACKEND_URL_DOC + "getgroupdocspermissionByGroup/" + idGroup, config)
        .then((response) => {
          if (response){
            localStorage.setItem("docsPermission", JSON.stringify(response[0]));
            const docsPermission = JSON.parse(localStorage.getItem("docsPermission"));
            setHasQuessDocs(docsPermission.Statut);
          }
          resolve();
        })
        .catch((error) => {
          console.error("Error in getgroupdocspermissionByGroup:", error);
          resolve();
        });
    });
  };
  const getgrouplmspermission = (idGroup) => {
    return new Promise((resolve) => {
      axios
        .get(BACKEND_URL_PORTAIL + "api/getgrouplmspermission/" + idGroup, config)
        .then((response) => {
          if (response){
            localStorage.setItem("lmsPermission", JSON.stringify(response[0]));
            const lmsPermission = JSON.parse(localStorage.getItem("lmsPermission"));
            setHasQuessLms(lmsPermission.Statut);
          }
          resolve();
        })
        .catch((error) => {
          console.error("Error in getgrouplmspermission:", error);
          resolve();
        });
    });
  };

  const getIcon = (label) => {
    switch (label) {
      case "QUESS-LOGS":
        return quessLogs;
      case "QUESSCONTRÔLE":
        return quessControle;
      case "QUESS-DOCS":
        return quessDocs;
      case "QUESS-COMPOUND":
        return quesscompound;
      case "QUESS-LMS":
        return quesslms;
      default:
        return null;
    }
  };

  const handleDocsClick = () => {
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("lang");
    const payload = { token, lang };
    const encoded = 'REROUTE:' + btoa(JSON.stringify(payload));

    const w = window.open('about:blank', '_blank');
    if (!w) {
      alert('Please allow pop-ups for this site.');
      return;
    }

    w.name = encoded;
    w.location = `${DOC_URL}/reRoute`;
  };

  const handleLogsClick = (type) => {
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("lang");
    const currentOrg = localStorage.getItem("currentOrg");
    const payload = { token, lang, type,currentOrg };
    const encoded = 'REROUTELOG:' + btoa(JSON.stringify(payload));

    const w = window.open('about:blank', '_blank');
    if (!w) {
      alert('Please allow pop-ups for this site.');
      return;
    }

    w.name = encoded;
    w.location = `${LOG_URL}/reroute/log`;
  };

  const handleLmsClick = () => {
    axios
      .get(BACKEND_URL_PORTAIL + "api/getLmsUsernameByQuessUsername/"+localStorage.getItem('username'), config)
      .then((response) => {
        if (response != "null") {
          axios
            .get(BACKEND_URL_PORTAIL + "api/directConnectLms/"+response, config)
            .then((response) => {
              window.open(response.lienConnexionDirect, '_blank');
            });
        } else {
          setOpenModalLoginLms(true);
        }
      });
  };

  const handleCompoundClick = () => {
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("lang");
    const username = localStorage.getItem("username");
    const idGroup = localStorage.getItem("currentOrg");
    const payload = { token, lang, username, idGroup };
    const encoded = 'REROUTECOMPOUNDING:' + btoa(JSON.stringify(payload));

    const w = window.open('about:blank', '_blank');
    if (!w) {
      alert('Please allow pop-ups for this site.');
      return;
    }

    w.name = encoded;
    w.location = `${COMPOUND_URL}/reRoute`;
  };

  const handleControleClick = (type) => {
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("lang");
    const currentOrg = localStorage.getItem("currentOrg");
    const payload = { token, lang, type,currentOrg };
    const encoded = 'REROUTECONTROLE:' + btoa(JSON.stringify(payload));

    const w = window.open('about:blank', '_blank');
    if (!w) {
      alert('Please allow pop-ups for this site.');
      return;
    }

    w.name = encoded;
    w.location = `${LOG_URL}/reroute/controle`;
  };

  const activateParentDropdown = useCallback((item) => {
    if (!item) return;
    
    // Ajouter 'active' à tous les éléments, même ceux avec des sous-menus
    item.classList.add("active");
    
    const parent = item.parentElement;
    
    if (parent) {
      const parent2El = parent.querySelector('ul');
      if (parent2El && parent2El.id !== "side-menu") {
        parent2El.classList.add("mm-show");
      }
      
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      
      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;
        
        if (parent3) {
          parent3.classList.add("mm-active");
          const parentLink = parent3.querySelector('a');
          if (parentLink && parentLink.classList.contains('has-arrow')) {
            parentLink.classList.add("mm-active");
          }
          
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            
            if (parent5) {
              parent5.classList.add("mm-show");
              const parent5Link = parent5.querySelector('a');
              if (parent5Link && parent5Link.classList.contains('has-arrow')) {
                parent5Link.classList.add("mm-active");
              }
            }
          }
        }
      }
    }
    
    scrollElement(item);
  }, []);

  const removeActivation = useCallback((items) => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      
      const parent = item.parentElement;
      if (parent) {
        const parent2El = parent.querySelector('ul');
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          
          if (parent3) {
            parent3.classList.remove("mm-active");
            const parentLink = parent3.querySelector('a');
            if (parentLink) {
              parentLink.classList.remove("mm-active");
            }
            
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              
              if (parent5) {
                parent5.classList.remove("mm-show");
                const parent5Link = parent5.querySelector('a');
                if (parent5Link) {
                  parent5Link.classList.remove("mm-active");
                }
              }
            }
          }
        }
      }
    }
  }, []);

  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname;
    const ul = document.getElementById("side-menu-item");
    
    if (!ul) return;
    
    const items = ul.getElementsByTagName("a");
    removeActivation(items);
    
    let matchingMenuItem = null;
    
    // Première passe: chercher une correspondance exacte
    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    
    // Si aucune correspondance exacte n'est trouvée, vérifier les sous-éléments d'administration
    const adminSubItems = [
      "/groups-management",
      "/users-management",
      "/roles-management",
      "/cleanroom-management"
    ];
    
    if (!matchingMenuItem && adminSubItems.includes(pathName)) {
      // Trouver l'élément Administration
      for (let i = 0; i < items.length; ++i) {
        if (items[i].textContent.includes("Administration")) {
          // Ajouter la classe active à l'élément Administration
          items[i].classList.add('active');
          matchingMenuItem = items[i];
          break;
        }
      }
      
      // Activer également le sous-élément correspondant
      if (matchingMenuItem) {
        const subItems = ul.querySelectorAll('.sub-menu a');
        for (let i = 0; i < subItems.length; ++i) {
          if (pathName === subItems[i].pathname) {
            subItems[i].classList.add('active');
            break;
          }
        }
      }
    }
    
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown, removeActivation]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    if (!dataLoaded || hasAdmin === null) return;

    const initializeMetisMenu = () => {
      if (metisMenuRef.current) {
        try {
          metisMenuRef.current.dispose();
        } catch (e) {
          console.log("Error disposing MetisMenu:", e);
        }
      }

      setTimeout(() => {
        const menuElement = document.getElementById("side-menu-item");
        if (menuElement) {
          try {
            metisMenuRef.current = new MetisMenu("#side-menu-item", {
              toggle: true,
              triggerElement: '.has-arrow',
              subMenu: '.sub-menu'
            });
            
            setTimeout(() => {
              const allActiveItems = document.querySelectorAll('#side-menu-item li.mm-active');
              allActiveItems.forEach(item => {
                if (!item.querySelector('a.mm-active')) {
                  item.classList.remove('mm-active', 'mm-show');
                  const subMenus = item.querySelectorAll('ul.mm-show');
                  subMenus.forEach(menu => menu.classList.remove('mm-show'));
                }
              });
              
              activeMenu();
            }, 150);
            
          } catch (error) {
            console.error("Error initializing MetisMenu:", error);
          }
        }
      }, 200);
    };

    initializeMetisMenu();

    return () => {
      if (metisMenuRef.current) {
        try {
          metisMenuRef.current.dispose();
        } catch (e) {
          console.log("Error cleaning up MetisMenu:", e);
        }
      }
    };
  }, [dataLoaded, hasAdmin, activeMenu]);

  useEffect(() => {
    if (metisMenuRef.current && dataLoaded) {
      setTimeout(() => {
        activeMenu();
      }, 50);
    }
  }, [props.router.location.pathname, dataLoaded]);

  useEffect(() => {
    return () => {
      if (metisMenuRef.current) {
        try {
          metisMenuRef.current.dispose();
        } catch (e) {
          console.log("Error in global cleanup:", e);
        }
      }
    };
  }, []);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <div className="vertical-menu" key={`menu-${dataLoaded}-${hasAdmin}-${menuKey}`}>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            {!loading && isUser && user ? (
              <div className="user-info align-items-center border-btm">
                <Avatar firstname={user.firstname} lastname={user.lastname} />
                <div className="ms-1 text-center">
                  <h6 className="username">{user.firstname} {user.lastname}</h6>
                </div>
              </div>
            ) : (
              <div className="user-info align-items-center text-center border-btm">
                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="loading-indicator">Loading...</div>
              </div>
            )}
            {dataLoaded ? (
              <ul className="metismenu list-unstyled" id="side-menu-item">
                {(sidebarData || [])
                  .filter((item) => {
                    if (item.label === "QUESS-LOGS") return hasQuessLogs;
                    if (item.label === "QUESSCONTRÔLE") return hasQuessControle;
                    if (item.label === "QUESS-DOCS") return hasQuessDocs;
                    if (item.label === "QUESS-LMS") return hasQuessLms;
                    if (item.label === "QUESS-COMPOUND") return hasQuessCompound;
                    if (item.label === "Administration") return hasAdmin;
                    return true;
                  })
                  .map((item, key) => (
                    <React.Fragment key={key}>
                      {item.isMainMenu ? (
                        <li className="menu-title">{props.t(item.label)}</li>
                      ) : (
                        <li key={key}>
                          {item.subItem ? (
                            // Pour les éléments avec sous-menu (comme Administration)
                            <Link
                              to="#"
                              className="has-arrow"
                              onClick={(e) => {
                                if (item.label === "Administration") {
                                  e.preventDefault();
                                  // Laisser MetisMenu gérer l'ouverture/fermeture
                                  return;
                                }
                                if (item.label === "QUESS-DOCS") {
                                  e.preventDefault();
                                  handleDocsClick();
                                } else if (item.label === "QUESS-LOGS") {
                                  e.preventDefault();
                                  handleLogsClick("1");
                                } else if (item.label === "QUESSCONTRÔLE") {
                                  e.preventDefault();
                                  handleControleClick("2");
                                } else if (item.label === "QUESS-COMPOUND") {
                                  e.preventDefault();
                                  handleCompoundClick()
                                } else if (item.label === "QUESS-LMS" || item.label === "QUESS-SGA") {
                                  e.preventDefault();
                                  handleLmsClick()
                                }
                              }}
                              onContextMenu={(e) => {
                                e.preventDefault();
                              }}
                            >
                              {getIcon(item.label) ? (
                                <img
                                  src={getIcon(item.label)}
                                  alt={item.label}
                                  style={{ width: "15px", marginRight: "10px" }}
                                />
                              ) : ( 
                                <i
                                  className={item.icon}
                                  style={{ marginRight: "5px" }}
                                ></i>
                              )} 
                              {item.issubMenubadge && (
                                <span
                                  className={
                                    "badge rounded-pill float-end " + item.bgcolor
                                  }
                                >
                                  {" "}
                                  {item.badgeValue}{" "}
                                </span>
                              )}
                              <span>{props.t(item.label)}</span>
                            </Link>
                          ) : (
                            // Pour les éléments sans sous-menu
                            <NavLink
                              to={item.url || "/#"}
                              className={({ isActive }) => 
                                isActive ? "active" : ""
                              }
                              onClick={(e) => {
                                if (item.label === "QUESS-DOCS") {
                                  e.preventDefault();
                                  handleDocsClick();
                                } else if (item.label === "QUESS-LOGS") {
                                  e.preventDefault();
                                  handleLogsClick("1");
                                } else if (item.label === "QUESSCONTRÔLE") {
                                  e.preventDefault();
                                  handleControleClick("2");
                                } else if (item.label === "QUESS-COMPOUND") {
                                  e.preventDefault();
                                  handleCompoundClick()
                                } else if (item.label === "QUESS-LMS" || item.label === "QUESS-SGA") {
                                  e.preventDefault();
                                  handleLmsClick()
                                }
                              }}
                              onContextMenu={(e) => {
                                e.preventDefault();
                              }}
                              end
                            >
                              {getIcon(item.label) ? (
                                <img
                                  src={getIcon(item.label)}
                                  alt={item.label}
                                  style={{ width: "15px", marginRight: "10px" }}
                                />
                              ) : ( 
                                <i
                                  className={item.icon}
                                  style={{ marginRight: "5px" }}
                                ></i>
                              )} 
                              {item.issubMenubadge && (
                                <span
                                  className={
                                    "badge rounded-pill float-end " + item.bgcolor
                                  }
                                >
                                  {" "}
                                  {item.badgeValue}{" "}
                                </span>
                              )}
                              <span>{props.t(item.label)}</span>
                            </NavLink>
                          )}
                          {item.subItem && (
                            <ul className="sub-menu">
                              {item.subItem.map((subItem, subKey) => (
                                <li key={subKey}>
                                  <NavLink
                                    to={subItem.link}
                                    className={({ isActive }) => 
                                      isActive ? "active" : ""
                                    }
                                    end
                                  >
                                    {props.t(subItem.sublabel)}
                                  </NavLink>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      )}
                    </React.Fragment>
                  ))}
              </ul>
            ) : (
              <div className="text-center p-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </SimpleBar>
        <LmsConnect open={openModalLoginLms} setOpen={setOpenModalLoginLms} />
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Sidebar));